var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H0.5V20H18.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84844 5.50039C5.84844 3.85205 7.38571 2.35039 9.49844 2.35039C11.6112 2.35039 13.1484 3.85205 13.1484 5.50039C13.1484 7.14874 11.6112 8.65039 9.49844 8.65039C7.38571 8.65039 5.84844 7.14874 5.84844 5.50039ZM9.49844 0.650391C6.6406 0.650391 4.14844 2.73046 4.14844 5.50039C4.14844 8.27032 6.6406 10.3504 9.49844 10.3504C12.3563 10.3504 14.8484 8.27032 14.8484 5.50039C14.8484 2.73046 12.3563 0.650391 9.49844 0.650391ZM2.84844 16.0004C2.84844 15.4303 3.33706 14.7632 4.67395 14.1964C5.94823 13.6562 7.70387 13.3504 9.49844 13.3504C11.2737 13.3504 13.0282 13.7077 14.3095 14.2771C14.9511 14.5623 15.434 14.8829 15.7445 15.2023C16.0513 15.5179 16.1484 15.7853 16.1484 16.0004C16.1484 16.0498 16.1315 16.1785 15.886 16.3825C15.6329 16.5928 15.2097 16.8157 14.5936 17.0153C13.3688 17.412 11.5903 17.6504 9.49844 17.6504C7.40654 17.6504 5.62808 17.412 4.40323 17.0153C3.78717 16.8157 3.36394 16.5928 3.1109 16.3825C2.86536 16.1785 2.84844 16.0498 2.84844 16.0004ZM9.49844 11.6504C7.543 11.6504 5.54864 11.9792 4.01043 12.6313C2.53482 13.2568 1.14844 14.3397 1.14844 16.0004C1.14844 16.7157 1.53331 17.2819 2.02437 17.69C2.50794 18.0918 3.15613 18.3983 3.87936 18.6326C5.33308 19.1034 7.30462 19.3504 9.49844 19.3504C11.6922 19.3504 13.6638 19.1034 15.1175 18.6326C15.8407 18.3983 16.4889 18.0918 16.9725 17.69C17.4636 17.2819 17.8484 16.7157 17.8484 16.0004C17.8484 15.2155 17.4768 14.5454 16.9634 14.0172C16.4535 13.4929 15.7645 13.0635 14.9999 12.7237C13.4687 12.0431 11.4731 11.6504 9.49844 11.6504Z",
    fill: "#CE9944"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.f60cdd307d34e623c4f496648bccf3c2.svg";
export { ForwardRef as ReactComponent };